import React from 'react';
import css from './OfferModal.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { manageDisableScrolling } from '../../../ducks/ui.duck';
import { Modal } from '../../../components';
import OfferForm from './OfferForm/OfferForm';
import { useIntl } from 'react-intl';
import { useConfiguration } from '../../../context/configurationContext';

import { sendOfferErrorSelector, sendOfferInProgressSelector } from '../ListingPage.duck';
import {
  transitionErrorSelector,
  transitionInProgress,
} from '../../TransactionPage/TransactionPage.duck';

const OfferModal = ({
  isOpen,
  onClose,
  authorDisplayName,
  isTransactionPage = false,
  onSubmit,
  title,
  listing,
  isCounterOffer,
  isInitialOffer,
  modalTitle,
}) => {
  const intl = useIntl();
  const config = useConfiguration();
  const dispatch = useDispatch();

  const submitInProgress = useSelector(sendOfferInProgressSelector);
  const sendOfferError = useSelector(sendOfferErrorSelector);

  const transitionInProgressState = useSelector(transitionInProgress);
  const transitionErrorState = useSelector(transitionErrorSelector);

  const inProgress = isTransactionPage ? transitionInProgressState : submitInProgress;
  const error = isTransactionPage ? transitionErrorState : sendOfferError;

  return (
    <Modal
      id="OfferModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
      modalTitle={modalTitle}
    >
      <div className={css.modalContent}>
        <OfferForm
          onSubmit={onSubmit}
          intl={intl}
          inProgress={inProgress}
          authorDisplayName={authorDisplayName}
          title={title}
          listing={listing}
          config={config}
          sendOfferError={error}
          listingTitle={title}
          isCounterOffer={isCounterOffer}
          isInitialOffer={isInitialOffer}
        />
      </div>
    </Modal>
  );
};

export default OfferModal;
